module.exports = __webpack_public_path__ + "img/shige.c709d0b0.jpg";